import styled from "styled-components";
import {ClockLastLoginDefaultBox} from "./clock-last-login.default.box";

export const ClockLastLoginSiBox = styled(ClockLastLoginDefaultBox)`
    background-color: ${({theme}) => theme.colors.background};
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background-color: ${props => props.theme.colors.brandPrimary};
    }  
`;
